import type { BookingState, Config, Service } from "@/types";
import { digitsOnly } from "./format";

/** Mensaje de confirmación de reserva para WhatsApp (texto plano). */
export function reservationMessage(
  config: Config,
  service: Service,
  booking: BookingState,
): string {
  const lines = [
    `Hola ${config.brand}! Quiero reservar una hora:`,
    "",
    `• Servicio: ${service.name}`,
    `• Fecha: ${booking.date ?? ""}`,
    `• Hora: ${booking.time ?? ""}`,
    `• Nombre: ${booking.name}`,
    `• Teléfono: ${booking.phone}`,
  ];
  if (booking.note) lines.push(`• Nota: ${booking.note}`);
  return lines.join("\n");
}

/** URL de wa.me con el mensaje pre-cargado. */
export function waLink(phoneWA: string, message: string): string {
  return `https://wa.me/${digitsOnly(phoneWA)}?text=${encodeURIComponent(message)}`;
}

/** URL de wa.me para un contacto (solo número). */
export function waChatLink(phone: string): string {
  const digits = digitsOnly(phone);
  return digits ? `https://wa.me/${digits}` : "https://wa.me/";
}

/** Abre WhatsApp en una pestaña nueva. */
export function openWhatsApp(phoneWA: string, message: string): void {
  window.open(waLink(phoneWA, message), "_blank", "noopener,noreferrer");
}
